export const Tooltips = {
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  View: 'View'
}